export const MATIC_PRODUCT_ID = "gid://shopify/Product/8107925471432";
export const MATIC_VARIANT_ID = "gid://shopify/ProductVariant/44258632302792";
export const MATIC_SELLING_PLAN_GROUP_NAME = "MATIC_SELLING_PLAN";
export const MATIC_SELLING_PLAN_ID = "gid://shopify/SellingPlan/2883158216";
export const MATIC_REFKIT_VARIANT_ID = "gid://shopify/ProductVariant/44753728143560";

export const DISCOUNTS = {
  "MATIC50": "50",
  "MATICVIP": "100",
  "LUKASZIEGLER": "50",
  "BOOTH": "100",
  "DOCK20": "20",
  "MATICDOGFEST50": "50",
}
